module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div name=\"form-content\" class=\"wh100 content\">\n    <div class=\"top\">\n        <h2>")
    ; __append(escapeFn( widget.title ))
    ; __append("</h2>\n        <div name=\"data\" class=\"clearfix\" style=\"min-height: 100px\">\n            <div>\n                <div name=\"filter\"></div>\n            </div>\n            <div>\n                <div name=\"grid\"></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"footer\">\n        <div name=\"back\" class=\"button\" on-click=\"onBackClick\">Назад</div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}